Array.prototype.each = function(callback) {
  this.forEach((_) => callback(_))
}

Array.prototype.merge = function(chunk) {
  this.push.apply(this, chunk)
}

Array.prototype.flatten = function() {
  [].concat.apply([], this)
}

Array.prototype.compact = function() {
  return this.filter(item => item != null)
}

Array.prototype.unique = function() {
  return this.filter(function(value, index, self) {
    return self.indexOf(value) === index
  })
}

Array.prototype.deleteAt = function(i) {
  this.splice(i, 1)
}

Array.prototype.random = function() {
  return this[Math.floor(Math.random()*this.length)]
}

Array.prototype.max = function() {
  var result = Math.max.apply(null, this)
  return result == -Infinity ? null : result
}

Array.prototype.min = function() {
  var result = Math.min.apply(null, this)
  return result == Infinity ? null : result
}

Array.prototype.delete =
  Array.prototype.remove = function() {
    var victim, victims = arguments,
      victimsCount = victims.length, victimPosition
    while (victimsCount && this.length) {
      victim = victims[--victimsCount]
      while ((victimPosition = this.indexOf(victim)) !== -1) {
        this.splice(victimPosition, 1)
      }
    }
    return this
  }

Array.prototype.extractOne = function(callback) {
  var result = null
  this.some(item => result = callback(item))
  return result
}

Array.prototype.extract = function(callback) {
  var result = [], value
  this.each(item => {
    value = callback(item)
    if (value) result.push(value)
  })
  return result
}

Date.prototype.addHours = function(h){
  this.setHours(this.getHours()+h)
  return this
}


// WEBPACK FOOTER //
// ./src/lib/sugar.js